import {Component} from "react";
import React from "react";
import PropTypes from 'prop-types';


class Loading extends Component {

    static propTypes = {
        /** Show / hide loader */
        show: PropTypes.bool
    };

    static defaultProps = {
        show:false
    };

    onClick(event){
        if (typeof(this.props.onClick)==="function"){
            this.props.onClick(event);
        }
    }

    render() {
        const {show} = this.props;

        return (
            <div className={show ? 'loading visible' : 'loading'}>
                <i className="fal fa-spinner-third fa-spin"></i>
            </div>
        );
    }
}

export default Loading;


// WEBPACK FOOTER //
// ./src/components/UI_Elements/Loading.js